import { createContext } from 'react';
import type { SharedValue } from 'react-native-reanimated';

type HomeScrollContextType = {
  headerVisible: SharedValue<number>; // 1 = visible, 0 = hidden
  onScrollY: (scrollY: number) => void;
};

export const HomeScrollContext = createContext<HomeScrollContextType | null>(
  null,
);